import { render } from "./PartTitle.vue?vue&type=template&id=3a43300b&scoped=true&ts=true"
import script from "./PartTitle.vue?vue&type=script&lang=ts"
export * from "./PartTitle.vue?vue&type=script&lang=ts"

import "./PartTitle.vue?vue&type=style&index=0&id=3a43300b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a43300b"]])

export default __exports__